import { initContract } from '@ts-rest/core';
import { z } from 'zod';

export const getTrackRouter = (c: ReturnType<typeof initContract>) =>
  c.router(
    {
      info: {
        summary: 'Track info event',
        method: 'POST',
        path: '/info',
        body: z.object({
          name: z.string(),
          properties: z.record(z.string(), z.unknown()).optional(),
          locale: z.string(),
          secureUserId: z.string().nullish(),
        }),
        responses: {
          200: z.literal('ok'),
        },
      },
    },
    {
      pathPrefix: '/track',
    },
  );
